import { render } from "./CollectionDailyReportListView.vue?vue&type=template&id=ad5a519c&scoped=true"
import script from "./CollectionDailyReportListView.vue?vue&type=script&lang=js"
export * from "./CollectionDailyReportListView.vue?vue&type=script&lang=js"

import "./CollectionDailyReportListView.vue?vue&type=style&index=0&id=ad5a519c&scoped=true&lang=css"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad5a519c"]])

export default __exports__